import { gql } from '@apollo/client';

export const REMOVE_CHARGE_FROM_ARREST = gql`
mutation removeChargeFromArrest($input: RemoveChargeFromArrestInput!) {
  removeChargeFromArrest(input: $input) {
    __typename
    clientMutationId
    errors
    arrestChargeUuid
  }
}
`
